<template>
  <BaseCard>
    <div
      :class="[
        $style.base,
        {
          [$style.smallScreen]: $screen === 's',
          [$style.isDefault]: isDefault
        }
      ]"
    >
      <div :class="$style.top">
        <BaseInput
          v-model="name"
          :label="$t('vat_rates.name')"
          required
          v-test="'vat-rate-name'"
        />
        <BaseInput
          v-if="!disablePercentage"
          v-model="percentage"
          type="number"
          unitLabel="percentage"
          :decimals="2"
          :label="$t('global.percentage')"
          :minValue="0"
          :maxValue="100"
          v-test="'vat-rate-percentage'"
        />
      </div>
      <div :class="$style.bottom">
        <div :class="$style.bottomLeft">
          <BaseRadio
            v-model="isDefault"
            :options="[
              {
                label: $t('vat_rates.use_as_default'),
                value: true
              }
            ]"
            v-test="'vat-rate-default'"
          />
          <BaseCheckbox
            v-model="disablePercentage"
            :label="$t('vat_rates.disable_percentage')"
            v-test="'vat-rate-disable-percentage'"
          />
        </div>
        <div :class="$style.delete">
          <BaseIcon
            name="delete"
            @click="$emit('delete')"
            v-test="'vat-rate-delete'"
          />
        </div>
      </div>
    </div>
  </BaseCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    vatRate: {
      type: Object,
      required: true,
      validator: (value) =>
        'name' in value && 'percentage' in value && 'default' in value,
    },
  },
  emits: ['delete', 'update'],
  computed: {
    name: {
      get() {
        return this.vatRate.name;
      },
      set(value: string) {
        this.$emit('update', {
          key: 'name',
          value,
        });
      },
    },
    percentage: {
      get() {
        return this.vatRate.percentage;
      },
      set(value: number) {
        this.$emit('update', {
          key: 'percentage',
          value,
        });
      },
    },
    isDefault: {
      get() {
        return this.vatRate.default;
      },
      set(value: boolean) {
        this.$emit('update', {
          key: 'default',
          value,
        });
      },
    },
    disablePercentage: {
      get() {
        return this.vatRate.percentage === null;
      },
      set(value: boolean) {
        this.$emit('update', {
          key: 'percentage',
          value: value ? null : 0,
        });
      },
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}

.top {
  display: flex;
  justify-content: space-between;
  gap: $spacing;

  .base.smallScreen & {
    flex-direction: column;
  }

  .base:not(.smallScreen) & {
    flex-direction: row;

    & > * {
      width: calc(50% - #{$spacing * 0.5});
    }
  }
}

.bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing;
}

.bottomLeft {
  display: flex;
  gap: $spacing;
}

.delete {
  .base.isDefault & {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
